<ion-content>
  <ion-toolbar>
    <ion-title>{{title}}</ion-title>

    <ion-buttons slot="primary">
      <ion-button icon-only (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="background-light position-sticky z-index-1 flex-box padding-right-s border-top-light-2 border-bottom-light-2" id="search-bar">
    <ion-icon class="padding-s" name="search" size="small"></ion-icon>
    <!-- ionInput fires more immediately, ionChange appears to have delayed propagation -->
    <ion-input
      #autocompletesearchbar
      (ionInput)="handleInput($event)"
      (keydown)="handleKeys($event)"
      (ionBlur)="cursorIdx = null"
      placeholder="Start typing"
      id="autocomplete-searchbar"
      type="text"
      [maxlength]="maxChars"
      [formControl]="searchControl"
      mode="md"
      [clearInput]="true"
    ></ion-input>
    @if (otherCode) {
      <span>{{searchString.length}}/{{maxChars}}&nbsp;</span>
    }
  </div>
  <div>
    <ion-list>
      <ion-list-header class="margin-bottom-0 justify-content-end" lines="none">
        @if (searchString.length > 2) {
          <ion-label class="margin-right-l font-default not-bold">{{resultList.length}} results</ion-label>
        }
        @if (searchString.length < 3) {
          <ion-label class="margin-right-l font-s not-bold"
            >Please enter more than 2 character for search.</ion-label
            >
          }
        </ion-list-header>
        @if (loading | async) {
          <app-loading-indicator></app-loading-indicator>
        }

        @if (!!shownResultsList.length) {
          @for (result of shownResultsList; track result; let i = $index) {
            <ion-button
              fill="clear"
              expand="full"
              class="font-default color-dark-1 cursor-pointer full-width margin-0"
              (click)="select(result)"
              [class.selected]="i == cursorIdx"
              mode="md"
              >
              <span class="padding-s"> {{ getSearchField(result) }}</span>
            </ion-button>
          }
        }
        @if (otherCode && searchString.length > 0 && !(loading | async)) {
          <ion-button
            fill="clear"
            expand="full"
            (click)="useOther()"
            class="full-width font-default color-dark-1 item item-block item-md cursor-pointer margin-0"
            >
            <span class="padding-s">Other (use what you typed)</span>
          </ion-button>
        }

        @if (page > 0 || hasNextPage()) {
          <ion-item lines="none">
            <div class="flex-box full-screen color-placeholder padding-right-l padding-left-l">
              @if (page > 0) {
                <!-- SonarQube alert: "tabIndex" should only be declared on interactive elements.-->
                <button type="button" (click)="gotoPrevPage()" class="page-link cursor-pointer flex-box"
                  ><span class="flex-box flex-end"><ion-icon name="chevron-back-sharp"></ion-icon></span> previous</button
                  >
                }
                <span>&nbsp;</span>
                @if (hasNextPage()) {
                  <button type="button" (click)="gotoNextPage()" class="page-link cursor-pointer flex-box"
                    >next <span class="flex-box flex-end"><ion-icon name="chevron-forward-sharp"></ion-icon> </span>
                  </button>
                }
              </div>
            </ion-item>
          }
        </ion-list>
      </div>
    </ion-content>
